import { use_store } from "../store";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/pro-regular-svg-icons";

interface FaqQuestionProps {
  question: string;
  answer: string;
}

export function FaqQuestion({ question, answer }: FaqQuestionProps) {
  const [is_open, set_is_open] = useState(false);

  return (
    <div className="border-[1px] border-lines rounded-[4px] overflow-hidden  bg-surface">
      <div
        className="w-full py-[16px] px-[20px] flex items-center justify-between bigt cursor-pointer hover:opacity-80 transition-colors"
        onClick={() => set_is_open(!is_open)}
      >
        <span className="">{question}</span>
        <FontAwesomeIcon
          icon={is_open ? faXmark : faPlus}
          className="text-[16px] text-primary"
        />
      </div>
      {is_open && (
        <div className="border-t-[1px] border-lines py-[16px] px-[20px] vsmallt">
          {answer}
        </div>
      )}
    </div>
  );
}

export default function FaqSection() {
  const { t, tool } = use_store();
  return (
    <div className="w-full flex flex-col items-center">
      <h2 className="stitle text-left w-full mb-[24px]">
        {tool
          ? t(
              `Lulu Loyal's ${tool
                .split("_")
                .map((x: string) => x[0].toUpperCase() + x.slice(1))
                .join(" ")} Tool`,
            )
          : t("Lulu Loyal's FAQ")}
      </h2>
      <div className="w-full flex flex-col gap-[12px]">
        <FaqQuestion
          question={t("Can I trust these results?")}
          answer={t(
            "Yes, our tech is best in class, and it's designed to be as accurate as possible. If you can't get the results you're looking for here, you can't get them anywhere. Our tech is the most advanced.",
          )}
        />
        <FaqQuestion
          question={t("Is this 100% anonymous?")}
          answer={t(
            "Yes, there's no way anyone could ever know, or see that you've searched for a person. They'll also never know you've searched for them either. We've made that our top priority.",
          )}
        />
        <FaqQuestion
          question={t("Can I catch cheaters with this?")}
          answer={t(
            "Yes, many people have, and many people have stopped themselves landing in heartbreak. You can use Lulu Loyal to make sure you're not interacting with people who will mess you around.",
          )}
        />
        <FaqQuestion
          question={t("Is this legal?")}
          answer={t(
            "All the data we gather is public and it's 100% legal to collect this data, and to interact with this data too. You're not doing anything which breaks any law anywhere by searching for someone.",
          )}
        />
        <FaqQuestion
          question={t("Why should I trust Lulu Loyal?")}
          answer={t(
            "Because we've been in your shoes, which is exactly why we built this product. What matters most to us, is to help other people find good people that won't mess them around.",
          )}
        />
      </div>
    </div>
  );
}
